export const COMPANY = 'COMPANY';
export const COMPANY_LIST = `${COMPANY}/LIST`;
export const COMPANY_SEARCH = `${COMPANY}/SEARCH`;
export const COMPANY_ALL = `${COMPANY}/ALL`;
export const COMPANY_GET_BY_ID = `${COMPANY}/GET_BY_ID`;
export const CREATE_COMPANY_AND_STORE = `${COMPANY}/CREATE_COMPANY_AND_STORE`;
export const COMPANY_CREATE_ACTION = `${COMPANY}/COMPANY_CREATE_ACTION`;
export const MERCHANT_CATEGORY_CODE = `${COMPANY}/MERCHANT_CATEGORY_CODE`;
export const GENERATE_HOP_URL = `${COMPANY}/GENERATE_HOP_URL`;
export const CLIENT_ALL = `${COMPANY}/CLIENT_ALL`;
export const UPDATE_KYC_STATUS = `${COMPANY}/UPDATE_KYC_STATUS`;
export const COMPANY_SELECT = `${COMPANY}/SELECT`;
export const COMPANY_ALL_INIT = `${COMPANY}/ALL_INIT`;
export const USER_CLIENTS = `${COMPANY}/USER_CLIENTS`;
